module.exports = __webpack_public_path__ + "static/img/home_new14.d6f651d2.jpg";